var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChangeDataType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3137_113438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28033 5.46967C4.57322 5.76256 4.57322 6.23744 4.28033 6.53033L2.56066 8.25H13.5C13.9142 8.25 14.25 8.58579 14.25 9C14.25 9.41421 13.9142 9.75 13.5 9.75H2.56066L4.28033 11.4697C4.57322 11.7626 4.57322 12.2374 4.28033 12.5303C3.98744 12.8232 3.51256 12.8232 3.21967 12.5303L0.21967 9.53033C-0.0732233 9.23744 -0.0732233 8.76256 0.21967 8.46967L3.21967 5.46967C3.51256 5.17678 3.98744 5.17678 4.28033 5.46967ZM19.7197 11.4697C20.0126 11.1768 20.4874 11.1768 20.7803 11.4697L23.7803 14.4697C24.0732 14.7626 24.0732 15.2374 23.7803 15.5303L20.7803 18.5303C20.4874 18.8232 20.0126 18.8232 19.7197 18.5303C19.4268 18.2374 19.4268 17.7626 19.7197 17.4697L21.4393 15.75H10.5C10.0858 15.75 9.75 15.4142 9.75 15C9.75 14.5858 10.0858 14.25 10.5 14.25H21.4393L19.7197 12.5303C19.4268 12.2374 19.4268 11.7626 19.7197 11.4697Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3137_113438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeDataType);
export default __webpack_public_path__ + "static/media/icon_change-data-type.f2150988fa2516fb5abf93e98f50376f.svg";
export { ForwardRef as ReactComponent };